import { render, staticRenderFns } from "./ProjectListPage.vue?vue&type=template&id=65daa2ea&scoped=true"
import script from "./ProjectListPage.vue?vue&type=script&lang=js"
export * from "./ProjectListPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectListPage.vue?vue&type=style&index=0&id=65daa2ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65daa2ea",
  null
  
)

export default component.exports